import React, { useState, useRef } from "react";
import styles from "./BubbleIcon.module.scss";
import { Question } from "assets/icons";
import Text from "components/text/Text";
import { useClickOutside } from "hooks";
import { getAllClassNames } from "helpers";
import Popup from "components/popup/Popup";

type IBubbleIcon = {
  text?: string;
  info: string;
  className?: string;
  isPopup?: boolean;
  popupTitle?: string;
  popupContent?: string;
};

export const BubbleIcon = ({ text, info, className, isPopup, popupTitle, popupContent }: IBubbleIcon) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === "Enter") {
      setShowDropdown(true);
    }
    if (event.key === "Escape") {
      setShowDropdown(false);
    }
  };

  useClickOutside(dropdownRef, () => setShowDropdown(false));

  const handleToggleVisibility = () => {
    if (popupRef.current) {
      popupRef.current.classList.toggle('show');
    }
  };

  const handleTooltipClick = () => {
    setShowPopup(prev => !prev);
    handleToggleVisibility();
  }

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={() => isPopup ? handleTooltipClick() : setShowDropdown(true)}
      onKeyDown={handleKeyDown} 
      className={getAllClassNames([styles.container, className])}
    >
      <Question className={styles.icon} />
      {text && <Text className={styles.title} text={text} />}
      {showDropdown && !showPopup && (
        <div ref={dropdownRef} className={styles.dropdown}>
          <Text className={styles.info} text={info} />
        </div>
      )}
      {isPopup && (
        <Popup
          ref={popupRef}          
          width={690} 
          onClose={() => handleToggleVisibility()}
        >
          <h3 className={styles.popupTitle}>{popupTitle}</h3>
          <div className={styles.contentClassName} dangerouslySetInnerHTML={{ __html: popupContent || "" }}></div>
        </Popup>
      )}
    </span>
  );
};